@if (userResource.value(); as user) {
  <ui-user-email
    (submitResult)="onUserEmailSubmit($event)"
    [email]="user.mail"
    [hasPending]="hasEmailChangeNotification()"
  ></ui-user-email>
}
